import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';
import {
	Table,
	TableHeader,
	TableBody,
	TableRow,
	TableHead,
	TableCell
} from '@/stories/Shadcn/Table/Table';
import { SyncResult } from '../../CustomerSupport/types';

interface FailedTemplatesTableProps {
	failedTemplates: SyncResult['failed_templates'];
	t: (key: string, params?: any) => string;
}

const FailedTemplatesTable: React.FC<FailedTemplatesTableProps> = ({ failedTemplates, t }) => {
	if (failedTemplates.length === 0) return null;

	return (
		<div className="mb-6">
			<div className="mb-2 text-orange-700">
				<Typography size="md" weight="medium">
					{t('FailedTemplates')} ({failedTemplates.length})
				</Typography>
			</div>
			<div className="max-h-60 overflow-y-auto border rounded">
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>{t('ClientId')}</TableHead>
							<TableHead>{t('Phone')}</TableHead>
							<TableHead>{t('Error')}</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{failedTemplates.map((record, idx) => (
							<TableRow key={idx}>
								<TableCell>{record.client_id}</TableCell>
								<TableCell>{record.phone}</TableCell>
								<TableCell className="text-orange-600">{record.error}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
		</div>
	);
};

export default FailedTemplatesTable;
